function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
import { ActionButton } from '@keen.io/ui-core';
import { PropertyItem } from '../../../../PropertyGroup';
import { ValueContainer, MotionPropertyItem } from './Value.styles';
import { MAX_WIDTH } from './constants';

var Value = function Value(_ref) {
  var value = _ref.value,
      removeHandler = _ref.removeHandler;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isDeletable = _useState2[0],
      setIsDeletable = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOverflow = _useState4[0],
      setIsOverflow = _useState4[1];

  var container = useRef(null);
  var deleteAnimation = {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.3,
        delay: 0.3
      }
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0
      }
    }
  };
  useEffect(function () {
    if (container.current && container.current.clientWidth >= MAX_WIDTH) setIsOverflow(true);
  }, [container]);
  return React.createElement(React.Fragment, null, React.createElement(PropertyItem, null, React.createElement(ValueContainer, {
    ref: container,
    whileHover: isOverflow ? {
      maxWidth: container.current.scrollWidth,
      textOverflow: 'clip'
    } : {},
    onHoverStart: function onHoverStart() {
      isOverflow && setIsDeletable(false);
    },
    onHoverEnd: function onHoverEnd() {
      isOverflow && setIsDeletable(true);
    }
  }, value)), React.createElement(AnimatePresence, null, isDeletable && React.createElement(MotionPropertyItem, Object.assign({}, deleteAnimation), React.createElement(PropertyItem, null, React.createElement(ActionButton, {
    onClick: function onClick() {
      return removeHandler(value);
    },
    action: "remove",
    borderRadius: "0 4px 4px 0",
    background: "transparent",
    backgroundHover: transparentize(0.85, colors.blue['100'])
  })))));
};

export default Value;